import { createRouter, createWebHistory } from "vue-router";
import constants from "../services/constants";
import HomeView from "../views/HomeView.vue";
import { auth } from "../firebase";
//import {useStore} from 'vuex'
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      requiresAuth: true,
      main: true,
    },
  },
  {
    path: "/posting",
    name: constants.posting,
    component: () => import("../views/PostingView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/post/id=:id",
    name: constants.singlePost,
    component: () => import("../views/PostView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/post/:userId/comments/id=:id",
    name: constants.comments,
    component: () => import("../views/CommentsView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/user/profile/id=:id",
    name: constants.profile,
    component: () => import("../views/ProfileView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/edit/post/id=:id",
    name: constants.editPost,
    component: () => import("../views/EditPostView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/delete/post/id=:id",
    name: constants.deletePost,
    component: () => import("../views/DeletePostView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/report/post/id=:id",
    name: constants.reportPost,
    component: () => import("../views/ReportView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/user/follower/id=:id",
    name: constants.follower,
    component: () => import("../views/FollowerView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/users",
    name: "Pasawitraan",
    component: () => import("../views/UsersView.vue"),
    meta: {
      requiresAuth: true,
      main: true,
    },
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: () => import("../views/NotificationsView.vue"),
    meta: {
      requiresAuth: true,
      main: true,
    },
  },
  {
    path: "/user/change-password/id=:id",
    name: constants.changePassword,
    component: () => import("../views/ChangePasswordView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/game",
    name: "Game",
    component: () => import("../views/GamesView.vue"),
    meta: {
      requiresAuth: true,
      main: true,
    },
  },
  {
    path: "/options",
    name: "Options",
    component: () => import("../views/OptionsView.vue"),
    meta: {
      requiresAuth: true,
      main: true,
    },
  },
  {
    path: "/search",
    name: constants.search,
    component: () => import("../views/SearchView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/edit-profile",
    name: constants.editProfile,
    component: () => import("../views/EditProfileView.vue"),
    meta: {
      requiresAuth: true,
      submenu: true,
    },
  },
  {
    path: "/edit-profile/change-photo",
    name: constants.editPhoto,
    component: () => import("../views/ChangePhotoView.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/about",
    name: constants.about,
    component: () => import("../views/AboutView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/sk",
    name: constants.term,
    component: () => import("../views/SkView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/kontributor",
    name: constants.contributor,
    component: () => import("../views/KontributorView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/register",
    name: constants.register,
    component: () => import("../views/RegisterView.vue"),
  },
  {
    path: "/login",
    name: constants.login,
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/reset-password",
    name: constants.resetPassword,
    component: () => import("../views/ResetPasswordView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (!savedPosition) {
          resolve({ left: 0, top: 0, behavior: "smooth" });
        }
        else {
          resolve(savedPosition)
        }
      }, 500);
    });
  },
});
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((route) => route.meta.requiresAuth);
  if (requiresAuth && !auth.currentUser) {
    next({
        path: '/login',
        query: { redirect: to.fullPath }
      }
    );
  } else if (!requiresAuth && auth.currentUser) {
    next("/");
  } else {
    next();
  }
});
export default router;
